var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10a.5.5 0 01.5.5V14H2v-3.5a.5.5 0 011 0V13h10v-2.5a.5.5 0 01.5-.5zM8 10c.28 0 .5-.22.5-.5V2.7l2.14 2.15c.1.1.23.15.36.15.12 0 .25-.05.35-.15.19-.2.19-.51 0-.71l-3-2.99c-.19-.2-.51-.2-.7 0l-3 2.99c-.19.2-.19.51 0 .71.2.19.51.19.71 0L7.5 2.7v6.8c0 .28.22.5.5.5z",
    fill: "#B5B5B5",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "3f720e8ca26139d0f9fce49668bd62c9.svg";
export { SvgIconExport as ReactComponent };